import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import Plotly from "plotly.js-dist-min";
import React, { useEffect, useRef } from "react";
const AVERAGE_DRAIN_PER_DAY = 16.7;
const EnergyLossChart = () => {
    const chartRef = useRef(null);
    const lineColor = "#2ecc71";
    useEffect(() => {
        if (!chartRef.current)
            return;
        const x = ["2025-05-28", "2025-05-29", "2025-05-30", "2025-05-31", "2025-06-01", "2025-06-02"];
        const y = [65, 50, 38, 25, 15, 7];
        const trace = {
            customdata: y.map((v) => v / AVERAGE_DRAIN_PER_DAY),
            fill: "tozeroy",
            fillcolor: "rgba(72, 201, 176, 0.25)",
            hovertemplate: `
                <b>%{x|%b %d, %Y}</b><br>
                SoC: %{y}%<br>
                Est. Time to 0%: %{customdata:.1f} days
                <extra></extra>
            `,
            line: {
                color: lineColor,
                width: 3
            },
            marker: {
                color: lineColor,
                size: 8
            },
            mode: "lines+markers",
            name: "State of Charge %",
            type: "scatter",
            x,
            y
        };
        const layout = {
            autosize: true,
            hovermode: "x unified",
            margin: { b: 40, l: 60, r: 30, t: 0 },
            xaxis: {
                showgrid: false,
                tickformat: "%b %d",
                title: "",
                type: "date"
            },
            yaxis: {
                dtick: 10,
                range: [0, 100],
                title: "Usable SoC (% of Total)"
            }
        };
        const config = {
            displayModeBar: false,
            responsive: true
        };
        Plotly.newPlot(chartRef.current, [trace], layout, config);
        const resizeObserver = new ResizeObserver(() => {
            if (chartRef.current) {
                Plotly.Plots.resize(chartRef.current);
            }
        });
        resizeObserver.observe(chartRef.current);
        return () => {
            resizeObserver.disconnect();
            if (chartRef.current) {
                Plotly.purge(chartRef.current);
            }
        };
    }, []);
    return (
    // eslint-disable-next-line no-inline-styles/no-inline-styles
    _jsxs("div", { "data-test": "energy-loss-chart", style: { display: "block", minHeight: 280, width: "100%" }, children: [_jsxs("div", { className: "flex justify-between items-center px-2 text-xs text-gray-500", children: [_jsxs("div", { children: ["Average idle drain rate:", " ", _jsxs("span", { className: "font-bold text-gray-800", children: [AVERAGE_DRAIN_PER_DAY, "% per day"] })] }), _jsxs("div", { className: "flex items-center gap-1.5", children: [_jsx("span", { children: "Legend:" }), _jsx("span", { className: "text-lg leading-none", style: { color: lineColor }, children: "\u25CF" }), _jsx("span", { className: "font-bold text-gray-800", children: "State of Charge %" })] })] }), _jsx("div", { "data-test": "energy-loss-chart-plotly-container", ref: chartRef, 
                // eslint-disable-next-line no-inline-styles/no-inline-styles
                style: { height: "100%", width: "100%" } }), _jsx("div", { className: "w-full text-center text-xs pb-2 font-semibold", children: "Idling Time (h)" })] }));
};
export default EnergyLossChart;
